import React from 'react';
import * as s from './ImageScan.theme';

export const ImageScan: React.FC = () => {
    return <>
        <p> Welcome to the image scanning page!</p>
        <s.ScanButton>I do nothing!</s.ScanButton>
    </>
}